export const sortByAlphabet = (fieldName) => (a, b) => {
  const firstValue = a[fieldName].toLowerCase();
  const nextValue = b[fieldName].toLowerCase();
  return firstValue.localeCompare(nextValue);
};

export const sortByValue = (fieldName) => (a, b) => a[fieldName] - b[fieldName];

export const sortByFnValue = (fn) => (a, b) => fn(a) - fn(b);
